import script from "./ArgonAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./ArgonAutocomplete.vue?vue&type=style&index=0&id=0e2e0a47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2e0a47"]])

export default __exports__